import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { IDocument, IDocumentQuery, IUploadDocument } from "../models/Document";
import { IPaginatedResponse } from "../models/Pagination";
import { documentService } from "../services/documentService";

export function useGetAllDocument(
  params: IDocumentQuery,
): UseQueryResult<IPaginatedResponse<IDocument>> {
  return useQuery({
    queryKey: ["document", params],
    queryFn: () => documentService.getDocument(params),
  });
}
export function useDownloadDocument(): UseMutationResult<
  string,
  unknown,
  number,
  unknown
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => documentService.downloadDocument(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["document"],
        predicate: (query) => query.queryKey[0] === "document",
      });
    },
  });
}
export function useViewDocument(): UseMutationResult<
  string,
  unknown,
  number,
  unknown
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => documentService.viewDocument(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["document"],
        predicate: (query) => query.queryKey[0] === "document",
      });
    },
  });
}

export function useUploadDocument(): UseMutationResult<
  IDocument,
  Error,
  IUploadDocument,
  unknown
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: IUploadDocument) => documentService.uploadDocument(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["document"] });
    },
  });
}
export function useDeleteDocument(): UseMutationResult<
  void,
  Error,
  number,
  unknown
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => documentService.deleteDocument(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["document"] });
    },
  });
}
